// Create new enums for filter routes here
export enum FilterType {
  storeCredit = 'STORE_CREDIT',
  claim = 'CLAIM',
  order = 'ORDER',
}
